const permissions = () => {
  let user = JSON.parse(localStorage.getItem("userData"));
  let permission = "ROLE_CORE_CONSULTAR";
  if (user) {
    permission = user.role === "PROFISSIONAL" ? "" : "ROLE_CORE_CONSULTAR";
  }
  return permission;
};

const menu = [
  {
    header: "Settings",
    action: permissions(),
    resource: "ACL",
  },
  {
    title: "Register",
    icon: "UserCheckIcon",
    action: "ROLE_ADMIM_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Administrative",
        route: "administrativeSettings",
        action: "ROLE_ADMIM_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Atendimento",
        route: "attendanceSettings",
        action: "ROLE_ATEND_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Events",
        route: "eventsSettings",
        action: "ROLE_CORE_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Financial",
        route: "financialSettings",
        action: "ROLE_FINAN_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Protocolo",
        route: "protocolSettings",
        action: "ROLE_PROT_CONSULTAR",
        resource: "ACL",
      },
      {
        title: "Orders de Serviços",
        route: "ordemServicoSettings",
        action: "ROLE_ORD_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Configurações",
    icon: "ToolIcon",
    action: "ROLE_SUPER_USER",
    resource: "ACL",
    children: [
      {
        title: "Cliente",
        route: "settings-client",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
      {
        title: "Diretoria",
        route: "settings-diretoria",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Auditoria",
    icon: "ShieldIcon",
    action: "ROLE_CORE_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Logs",
        route: "audit-logs",
        action: "ROLE_CORE_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
  {
    title: "Access",
    icon: "UserIcon",
    action: "ROLE_CORE_CONSULTAR",
    resource: "ACL",
    children: [
      {
        title: "Users",
        route: "usersSettings",
        action: "ROLE_SUPER_USER",
        resource: "ACL",
      },
      {
        title: "Profile",
        route: "profileSettings",
        action: "ROLE_PERFIL_CONSULTAR",
        resource: "ACL",
      },
    ],
  },
];

export default menu;
